export default __webpack_public_path__ + "static/media/cyclops_8.a27e6c86.svg";